// extracted by mini-css-extract-plugin
export default {"general":"ExamQuestion_general__tGlvc","question":"ExamQuestion_question__Uyaqx","answer":"ExamQuestion_answer__N2zmD"};